import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../auth/AuthContext';

export default function Login() {
  const { setCredential } = useAuth();

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1.5rem',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: '28rem' }}>
        <h2 style={{ marginBottom: '0.5rem' }}>Sign in to Dataviewer</h2>
        <p style={{ color: '#666', margin: 0 }}>
          Use your @shinkei.systems Google Workspace account to continue.
        </p>
      </div>
      <GoogleLogin
        onSuccess={setCredential}
        onError={() => {
          window.alert('Google sign-in failed. Please try again.');
        }}
        useOneTap
        auto_select
        hosted_domain="shinkei.systems"
        theme="outline"
        size="large"
        text="signin_with"
      />
    </div>
  );
}
